<template>
  <div id="contentManage">
    <div
      v-show="$route.name !== 'make'"
      class="bread"
    >
      <div class="bread-content">
        <el-button
          size="mini"
          plain
          type="primary"
          @click="back"
        >
          <i class="el-icon-arrow-left" />返回
        </el-button>
        <span style="margin-left: 12px">
          <span
            class="breadHead"
            @click="$router.go(-1)"
          >网页管理</span>
          <span style="margin: 0 9px; color: #c0c4cc; font-weight: 700">/</span>{{ name }}
        </span>
      </div>
      <div
        v-show="showDow"
        class="right"
      >
        <div
          class="right_title"
          @click.stop="showSiteStatus"
        >
          <div class="right_siteName">
            {{ siteName }}
          </div>
          <img
            style="margin-left: 10px; vertical-align: -2px"
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAOCAYAAADJ7fe0AAAAAXNSR0IArs4c6QAAACJJREFUKBVj/A8EDBQCJgr1j2rHEQKMo7GDI2QGg/DgiR0Av0UL/pWSRFsAAAAASUVORK5CYII="
          >
        </div>
        <div
          v-show="showSiteBox"
          class="dalogBox"
          @click="showSiteBox = false"
        >
          <div class="siteBox">
            <div
              v-for="(item, index) in siteList"
              :key="index"
              class="siteBox_item"
            >
              <div>
                <div
                  class="site_btn"
                  :class="item.defaultStatus == 1 ? 'site_active' : ''"
                  @click="checkSite(item, index, 1)"
                >
                  {{ item.name }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-show="$route.name !== 'make'"
      class="tabs"
    >
      <div>
        <div
          v-for="(tab, index) in tabs"
          :key="index"
          class="tab"
          :class="currentTab === index ? 'active' : ''"
          @click="changeTab(tab, index)"
        >
          <span>{{ tab.label }}</span>
        </div>
      </div>

      <div>
        <el-button
          v-show="websiteMsg&&websiteMsg.webTemplate"
          class="plainBtn"
          size="small"
          @click="preview('web')"
        >
          预览web
        </el-button>
        <el-button
          v-show="websiteMsg&&websiteMsg.h5Template&&websiteMsg.webTemplate"
          class="plainBtn"
          size="small"
          @click="preview('h5')"
        >
          预览H5
        </el-button>
        <el-button
          v-show="websiteMsg&&websiteMsg.h5Template&&!websiteMsg.webTemplate"
          class="plainBtn"
          size="small"
          @click="preview('h5')"
        >
          预览
        </el-button>
        <el-button
          class="plainBtn"
          size="small"
          @click="showDetail"
        >
          站点详情
        </el-button>
      </div>
    </div>
    <router-view />
    <!-- 站点信息 -->
    <mix-dialog
      ref="editDia"
      :modal="true"
      width="560px"
      class="right-dialog"
      :visible.sync="showEditDia"
      @close="handleClose"
    >
      <div
        slot="title"
        class="dialog-title"
      >
        <span>站点信息</span>
      </div>
      <div class="dialogBody min-scrollbar">
        <div class="dialogBodyContent">
          <el-tabs
            v-model="activeName"
            stretch
          >
            <!-- 站点信息页 -->
            <el-tab-pane
              label="站点信息"
              name="pageInfo"
            >
              <page-form
                v-if="showEditDia"
                ref="pageForm"
                :form="siteForm"
                mode="edit"
              />
            </el-tab-pane>
            <!-- 维护人员页 -->
            <el-tab-pane
              label="维护人员"
              name="workers"
            >
              <el-form
                v-if="workerForm.siteOwner.userName"
                ref="workerForm"
                :rules="workerRules"
                :model="workerForm"
                label-width="80px"
              >
                <el-form-item
                  prop="siteOwner"
                  label="站长"
                >
                  <div class="workerDiv">
                    <el-image
                      class="el-img"
                      :src="workerForm.siteOwner.avatarUrl"
                    >
                      <div
                        slot="error"
                        class="image-slot"
                      >
                        <div class="el-img">
                          {{ workerForm.siteOwner.userName.substr(-2, 2) }}
                        </div>
                      </div>
                    </el-image>
                    <div class="workerDivRight">
                      <span :title="workerForm.siteOwner.userName">{{
                        workerForm.siteOwner.userName.length > 5
                          ? workerForm.siteOwner.userName.substr(0, 5) + "..."
                          : workerForm.siteOwner.userName
                      }}</span>
                      <span>{{
                        workerForm.siteOwner.phone
                          ? workerForm.siteOwner.phone
                          : "133xxxxxxxx"
                      }}</span>
                    </div>
                    <img
                      v-if="(client === 'back') "
                      class="delete-icon"
                      src="../../../../assets/icon/edit_worker_green.png"
                      @click="changeSiteOwner"
                    >
                  </div>
                </el-form-item>
                <el-form-item
                  prop="siteWorker"
                  label="编辑人员"
                >
                  <div style="display: flex; flex-wrap: wrap">
                    <div
                      v-for="(item, index) in workerForm.siteWorker"
                      :key="index"
                      class="workerDiv"
                    >
                      <el-image
                        class="el-img"
                        :src="item.avatarUrl"
                      >
                        <div
                          slot="error"
                          class="image-slot"
                        >
                          <div class="el-img">
                            {{ item.userName.substr(-2, 2) }}
                          </div>
                        </div>
                      </el-image>
                      <div class="workerDivRight">
                        <span :title="item.userName">{{
                          item.userName.length > 5
                            ? item.userName.substr(0, 5) + "..."
                            : item.userName
                        }}</span>
                        <span>{{
                          item.phone ? item.phone : "133xxxxxxxx"
                        }}</span>
                      </div>
                      <!-- v-if="client === 'back' || (client === 'front' && $store.getters['system/getSuperAuth'])" -->
                      <img
                        v-if="(client === 'back' || identity === 1)"
                        class="delete-icon"
                        src="../../../../assets/icon/icon_worker_delete.png"
                        @click="deleteSiteWorker(item.userId)"
                      >
                    </div>
                  </div>
                  <el-button
                    v-if="(client === 'back' || identity === 1)"
                    style="margin-top: 12px"
                    size="medium"
                    type="primary"
                    @click="addWorker"
                  >
                    +添加编辑人员
                  </el-button>
                </el-form-item>
              </el-form>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
      <div
        v-if="client === 'back' && authority"
        class="add-match"
      >
        <transition name="el-zoom-in-bottom">
          <div class="btn-box-fixed">
            <el-button
              size="medium"
              class="plainBtn"
              @click="showEditDia = false"
            >
              取消
            </el-button>
            <el-button
              size="medium"
              type="primary"
              @click="onSubmit"
            >
              提交
            </el-button>
          </div>
        </transition>
      </div>
    </mix-dialog>
    <!-- 添加成员模块 -->
    <el-dialog
      :close-on-click-modal="false"
      width="500px"
      :visible.sync="addMemberDialog"
      :append-to-body="true"
    >
      <div
        slot="title"
        class="dialog-title"
      >
        <span>{{ addMemberTitle }}</span>
      </div>
      <div class="cooperative-project-container">
        <div>
          <el-autocomplete
            v-model="add_member.userName"
            class="input-with-select"
            style="width: 280px"
            :hide-loading="true"
            :fetch-suggestions="querySearch"
            placeholder="请输入姓名/手机号进行搜索"
            @select="addToNewMember"
          />
          <el-button
            type="primary"
            style="float: right"
            size="small"
            @click="addNewMember"
          >
            添加
          </el-button>
        </div>
        <div>
          <div style="margin-top: 10px">
            <span style="color: #999; margin-right: 10px">成员数</span>
            <span style="color: #999">{{ newMembers.length }}人</span><br>
            <div
              v-for="(itm, index) in newMembers"
              :key="index"
              class="singleMember"
              style="margin-right: 10px; margin-top: 10px"
            >
              {{ itm.userName }}
              <i
                class="el-icon-close close-span"
                style="cursor: pointer"
                @click="deleteNewMember(itm, index)"
              />
            </div>
          </div>
        </div>
      </div>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          size="small"
          class="btn-plain"
          @click="addMemberDialog = false"
        >
          取 消
        </el-button>
        <el-button
          size="small"
          type="primary"
          @click="confirmAddNewMember"
        >
          确 认
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import api from '../../pageMana/proxy';
import pageForm from '../../pageMana/list/pageForm';
export default {
    name: 'ContentManage',
    components: { pageForm },
    data () {
        return {
            newMembers: [], // 即将新增的成员
            add_member: {}, // 新增的成员
            addMemberDialog: false,
            addMemberTitle: '',
            workerRules: {
                siteOwner: {
                    required: true,
                    message: '请选择站长',
                },
            },
            workerForm: {
                // 站点信息的编辑人员form
                siteOwner: {},
                siteWorker: [],
            },
            siteName: null,
            siteForm: {
                // 站点信息form
                id: '',
                name: '', // 站点名称
                logo: '', // 站点logo
                orgType: '0',
                orgId: '1',
                description: '', // 网站描述
                webTemplate: '', // 网站web模板
                h5Template: '', // 网站H5模板
                address: '', // 网站访问地址
                addressId: '', // 网站访问id
                level: '3', // 栏目层级
            },
            showSiteBox: false,
            siteList: null,
            activeName: 'pageInfo',
            showEditDia: false,
            showDow: true,
            tabs: [
                { label: '内容管理', routeName: 'contentManage' },
                { label: '轮播图管理', routeName: 'carousel' },
                { label: '页面管理（H5）', routeName: 'page' },
                { label: '页面管理（web）', routeName: 'webpage' },
            ],
            stid: null, // 用做监听路由变化
            currentTab: 0,
            pageType: 0, // 0 浏览, 1 制作
            stack: Number(this.$route.query.stack) || -1,
            websiteMsg: {},
        };
    },
    computed: {
        client () {
            // let res = 'back';
            // this.$route.matched.forEach(r => {
            //     if (r.meta.client) {
            //         res = r.meta.client;
            //     }
            // });
            // return res;
            if (this.$route.path.indexOf('/pageMana/') > -1) return 'back';
            return this.$route.query.client === 'back' ? 'back' : 'front';
        },
        identity () {
            return this.$store.getters['system/getSiteList'][0]
                ? this.$store.getters['system/getSiteList'][0].identity
                : null;
        },
        userIdentity () {
            return this.$store.getters['global/userIdentity'];
        },
        authority () {
            return this.userIdentity === 1 || this.userIdentity === 2;
        },
        siteId () {
            return this.$route.query.siteId || (this.$store.getters['system/getSiteList'].length > 0 ? this.$store.getters['system/getSiteList'][0].siteId : null);
        },
        name () {
            return this.$route.query.name || (this.$store.getters['system/getSiteList'].length > 0 ? this.$store.getters['system/getSiteList'][0].name : '');
        },
        orgId () {
            return this.$store.getters['global/orgId'];
        },
    },
    watch: {
        $route () {
            this.getCurrentTab();
            this.stid = this.$route.query.siteId;
        },
        stid () {
            if (this.stid) {
                this.showDow = false;
                sessionStorage.setItem('urlSiteId', this.$route.query.siteId);
            } else {
                this.showDow = true;
                sessionStorage.removeItem('urlSiteId');
            }
        },
        orgId () {
            if (!this.siteId) return this.$router.replace({ name: 'pageDetail', query: { client: 'back' } });
        },
    },
    created () {
        console.log(123123, this.identity);
        console.log(this.$store.getters['system/access']);
        if (!this.siteId) return this.$router.replace({ name: 'pageDetail', query: { client: 'back' } });
        this.getCurrentTab();
        this.install();
        this.getWebSiteMsg();
        if (this.$route.query.siteId) {
            this.showDow = false;
            sessionStorage.setItem('urlSiteId', this.$route.query.siteId);
        } else {
            this.showDow = true;
            sessionStorage.removeItem('urlSiteId');
        }
    },
    methods: {
        back () {
            if (this.client === 'back') {
                this.$router.replace({ name: 'pageDetail', query: { client: 'back' } });
            } else {
                this.$router.go(this.stack);
            }
        },
        install3 () {
            api.install().then(res => {
                if (res.errcode === 0) {
                    if (res.data.length > 0) {
                        window.yxpapi.store.commit('system/mu_siteList', res.data);
                        if (window.yxpapi.store.getters['system/access'].indexOf('04299001') === -1) {
                            window.yxpapi.store.commit('system/mu_actionCodes', [{
                                actions: [
                                    {
                                        code: '04299001',
                                        name: '有前台权限',
                                    },
                                ],
                                authType: 'custom',
                            }]);
                        }
                    } else {
                        let actionCodes = JSON.parse(JSON.stringify(window.yxpapi.store.state.system.actionCodes));
                        let index = -1;
                        actionCodes.forEach((item, i) => {
                            if (item.actions[0].code === '04299001') index = i;
                        });
                        if (index > -1) {
                            actionCodes.splice(index, 1);
                            window.yxpapi.store.commit('system/mu_siteList', []);
                            window.yxpapi.store.commit('system/set_actionCodes', actionCodes);
                        }
                    }
                } else {
                    this.$message.error(res.errmsg);
                }
            });
        },
        // 获取站点模板信息
        getWebSiteMsg () {
            let params = {
                siteId: this.siteId,
            };
            api.websiteInfo(params).then(res => {
                if (res.errcode === 0) {
                    this.websiteMsg = res.data.value;
                    sessionStorage.setItem('websiteMsg', JSON.stringify(this.websiteMsg));
                    if (!this.websiteMsg.webTemplate) {
                        console.log(111, this.tabs.length - 1);
                        this.tabs.splice(3);
                    } else if (!this.websiteMsg.h5Template) {
                        this.tabs.splice(2, 1);
                    }
                    // if (this.websiteMsg.webTemplateId === 5) { // WEB-004
                    //     const index = this.tabs.findIndex(itm => itm.routeName === 'webpage');
                    //     if (index > -1) this.tabs.splice(index, 1);
                    // }
                    console.log(111, this.websiteMsg);
                } else {
                    this.$message.error(res.errmsg);
                }
            });
        },
        getCurrentTab () {
            switch (this.$route.name) {
                case 'make':
                case 'column':
                    this.currentTab = 0;
                    break;
                case 'carousel':
                    this.currentTab = 1;
                    break;
                case 'page':
                    this.currentTab = 2;
                    break;
                case 'webpage':
                    this.currentTab = 3;
                    if (!this.websiteMsg.h5Template) {
                        this.currentTab = 2;
                    }
                    break;
                default:
                    this.currentTab = 0;
                    break;
            }
        },
        confirmAddNewMember () {
            // 确认添加编辑人员
            if (this.newMembers.length === 0) {
                this.$message.error('请选择成员');
                return;
            }
            let arr = [];
            for (let itm of this.newMembers) {
                arr.push(itm.userId);
            }
            for (let itm of this.workerForm.siteWorker) {
                arr.push(itm.userId);
            }
            // let params = {
            //     siteId: this.siteId,
            //     targetUserIds: arr,
            // };
            // api.addBatch(params).then(res => {
            //     if (res.errcode === 0) {
            //         this.$message.success('添加成功');
            //         this.addMemberDialog = false;
            //         this.install3();
            //         this.getWorkers();
            //     } else {
            //         this.$message.error(res.errmsg);
            //     }
            // });
            if (this.addMemberTitle === '修改站长') {
                let params = {
                    siteId: this.siteId,
                    userId: arr[0],
                };
                api.updateStationmaster(params).then((res) => {
                    if (res.errcode === 0) {
                        this.$message.success('修改成功');
                        this.install();
                        this.addMemberDialog = false;
                        this.getWorkers();
                        // this.init();
                    } else {
                        this.$message.error(res.errmsg);
                    }
                });
            } else { // 添加编辑人员
                let params = {
                    siteId: this.siteId,
                    targetUserIds: arr,
                };
                api.addBatch(params).then((res) => {
                    if (res.errcode === 0) {
                        this.$message.success('添加成功');
                        this.addMemberDialog = false;
                        this.install();
                        this.getWorkers();
                    } else {
                        this.$message.error(res.errmsg);
                    }
                });
            }
        },
        deleteNewMember (itm, index) {
            // 成员 X按钮
            this.newMembers.splice(index, 1);
        },
        addNewMember () {
            // 成员 添加按钮
            let me = this;
            if (!me.add_member.userId) {
                me.$message.error('请选择正确成员');
                return;
            }
            if (me.add_member.userName) {
                let result = me.newMembers.some(item => {
                    if (parseInt(item.userId) === me.add_member.userId) {
                        return true;
                    }
                });
                let result1 = me.workerForm.siteWorker.some(item => {
                    if (parseInt(item.userId) === me.add_member.userId) {
                        return true;
                    }
                });
                if (result || result1) {
                    me.$message.error('已存在该成员');
                } else {
                    me.newMembers.push(me.add_member);
                    me.add_member = {};
                }
            } else {
                me.$message.error('请选择成员');
            }
        },
        addToNewMember (data) {
            // 添加时选择某个成员
            this.add_member = data;
        },
        querySearch (queryString, cb) {
            // 搜索成员
            this.searchResult = [];
            if (queryString === undefined || queryString === '') {
                return;
            }
            let params = {
                userName: queryString, // 手机号，名称
            };
            api.searchUser(params).then(r => {
                if (r.errcode === 0) {
                    for (let i = 0; i < r.data.list.length; i++) {
                        let item = {
                            value: `${r.data.list[i].realName}（${r.data.list[i].orgUserName}）--${r.data.list[i].phone}`,
                            userId: r.data.list[i].userId,
                            userName: r.data.list[i].realName,
                            telephone: r.data.list[i].phone,
                        };
                        this.searchResult.push(item);
                    }
                } else {
                    this.$message.error(r.errmsg);
                    return;
                }
                cb(this.searchResult);
            });
        },
        checkSite (item, index, status) {
            this.siteList.forEach(e => {
                e.defaultStatus = 0;
            });
            this.siteList[index].defaultStatus = 1;
            this.submitSite();
        },
        submitSite () {
            let siteId = null;
            this.siteList.forEach(e => {
                if (e.defaultStatus === 1) {
                    siteId = e.siteId;
                }
            });
            console.log(siteId);
            let params = {
                siteId: siteId,
            };
            api.switchInstall(params).then(res => {
                if (res.errcode === 0) {
                    this.showSiteBox = false;
                    this.install2();
                    // window.yxpapi.store.commit("system/mu_siteList", res.data);
                } else {
                    this.$message.error(res.errmsg);
                }
            });
        },
        install () {
            api.install().then(res => {
                if (res.errcode === 0) {
                    this.siteList = res.data;
                    this.siteName = this.siteList[0].name;
                    window.yxpapi.store.commit('system/mu_siteList', res.data);
                    console.log('22');
                } else {
                    this.$message.error(res.errmsg);
                }
            });
        },
        install2 () {
            api.install().then(res => {
                if (res.errcode === 0) {
                    this.siteList = res.data;
                    this.siteName = this.siteList[0].name;
                    window.yxpapi.store.commit('system/mu_siteList', res.data);
                    this.$router.go(0);
                } else {
                    this.$message.error(res.errmsg);
                }
            });
        },
        onSubmit () {
            // 编辑站点
            this.$refs.pageForm.$refs.form.validate((valid) => {
                if (valid) {
                    let params = {
                        id: this.siteForm.id,
                        name: this.siteForm.name,
                        logo: this.siteForm.logo,
                        orgType: this.siteForm.orgType,
                        orgId: this.siteForm.orgType === '0' ? '1' : this.siteForm.orgId, // 站点单位
                        description: this.siteForm.description,
                        webTemplate: this.siteForm.webTemplate,
                        h5Template: this.siteForm.h5Template,
                        websiteAddress: this.siteForm.address,
                        addressId: this.siteForm.addressId,
                        columnLevel: this.siteForm.level,
                        userId: this.workerForm.siteOwner.userId,
                        isLogin: this.siteForm.isLogin,
                        copyright: this.siteForm.copyright,
                        icpFilingCode: this.siteForm.icpFilingCode,
                        policeFilingCode: this.siteForm.policeFilingCode,
                    };
                    api.saveWebsite(params).then(res => {
                        if (res.errcode === 0) {
                            this.$message.success('保存成功');
                            this.showAddDia = false;
                            this.showEditDia = false;
                            this.install3();
                            this.init();
                        } else {
                            this.$message.error(res.errmsg);
                        }
                    });
                }
            });
        },
        showSiteStatus () {
            this.showSiteBox = !this.showSiteBox;
        },
        closeSitebox () {
            this.showSiteBox = false;
        },
        addWorker () {
            // 打开添加编辑人员弹窗
            this.newMembers = [];
            this.addMemberTitle = '添加编辑人员';
            this.addMemberDialog = true;
        },
        changeSiteOwner () {
            // 修改站长
            this.newMembers = [];
            this.addMemberTitle = '修改站长';
            this.addMemberDialog = true;
        },
        deleteSiteWorker (id) {
            // 删除编辑人员
            this.$confirm('确定删除?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            }).then(() => {
                let params = {
                    siteId: this.siteId,
                    targetUserId: id,
                };
                api.deleteUsers(params).then(res => {
                    if (res.errcode === 0) {
                        this.$message.success('删除成功');
                        this.install3();
                        this.getWorkers();
                    } else {
                        this.$message.error(res.errmsg);
                    }
                });
            });
        },
        handleClose () {
            // 关闭弹窗清空数据
            this.siteForm = {
                name: '',
                logo: '',
                orgType: '0',
                orgId: '1',
                description: '',
                webTemplate: '',
                h5Template: '',
                address: '',
                addressId: '',
                level: '3',
            };
        },
        changeTab (tab, index) {
            this.stack -= 1;
            console.log('this.stack==================');
            console.log(this.stack);
            if (this.$route.query.siteId) {
                this.$router.push({
                    name: tab.routeName,
                    query: { client: this.client, siteId: this.$route.query.siteId, name: this.name, stack: this.stack, webTemplate: this.websiteMsg.webTemplate },
                });
            } else {
                this.$router.push({ name: tab.routeName, query: { client: this.client, stack: this.stack, webTemplate: this.websiteMsg.webTemplate } });
            }
            this.currentTab = tab.routeName;
        },
        changePageType (pageType) {
            this.pageType = pageType;
        },
        preview (type) {
            if (type === 'h5') {
                let url = this.$router.resolve({ name: 'mobileModules' });
                window.open(url.href);
            } else if (type === 'web') {
                if (this.websiteMsg.webTemplate === 'WEB-004' && window.yxpapiConfig.env !== 'development') {
                    const host = window.yxpapiConfig.env === 'production' ? 'www.youxuezixishi.com' : 'www-test.youxuezixishi.com';
                    window.open(`https://${host}/yxp-page-manage/#/web004/home?siteId=${this.siteId}&preview=1`);
                } else {
                    let url = this.$router.resolve({ name: 'webModulePage', query: { noLogin: true, preview: 1 } });
                    window.open(url.href);
                }
            }
        },
        showDetail () {
            this.activeName = 'pageInfo';
            let params = {
                siteId: this.siteId,
            };
            api.websiteInfo(params).then(res => {
                if (res.errcode === 0) {
                    this.siteForm.from = this.client;
                    this.siteForm.id = res.data.value.id;
                    this.siteForm.name = res.data.value.name;
                    this.siteForm.logo = res.data.value.logo;
                    this.siteForm.orgType = String(res.data.value.orgType);
                    this.siteForm.orgId = res.data.value.orgId;
                    this.siteForm.orgName = res.data.value.orgName;
                    this.siteForm.description = res.data.value.description;
                    this.siteForm.webTemplate = res.data.value.webTemplate;
                    this.siteForm.h5Template = res.data.value.h5Template;
                    this.siteForm.address = res.data.value.websiteAddress;
                    this.siteForm.addressId = res.data.value.addressId;
                    this.siteForm.level = res.data.value.columnLevel;
                    this.siteForm.isLogin = res.data.value.isLogin;
                    this.siteForm.copyright = res.data.value.copyright;
                    this.siteForm.icpFilingCode = res.data.value.icpFilingCode;
                    this.siteForm.policeFilingCode = res.data.value.policeFilingCode;
                    this.showEditDia = true;
                    this.$refs.editDia.watchConfirm(this.siteForm);
                } else {
                    this.$message.error(res.errmsg);
                }
                this.getWorkers();
            });
        },
        getWorkers () {
            // 获取站点的工作人员
            let params = {
                siteId: this.siteId,
            };
            api.maintainers(params).then(res => {
                if (res.errcode === 0) {
                    this.workerForm.siteWorker = [];
                    for (let itm of res.data.list) {
                        if (itm.identity === 1) {
                            this.workerForm.siteOwner = itm;
                        } else {
                            this.workerForm.siteWorker.push(itm);
                        }
                    }
                } else {
                    this.$message.error(res.errmsg);
                }
            });
        },
    },
};
</script>

<style scoped lang="scss">
.singleMember {
  padding: 0 8px;
  height: 26px;
  line-height: 26px;
  background-color: #eee;
  margin-right: 10px;
  display: inline-block;
  text-align: center;
  background: #dcfcf0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.dialogBodyTitle {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.dialogBodyContent {
  width: 100%;
  margin-top: 12px;
  margin-bottom: 12px;
  width: 96%;
}
.workerDiv {
  margin-bottom: 12px;
  position: relative;
  margin-right: 24px;
  width: 180px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px dashed #ccc;
  padding: 0 8px;
    .el-img {
        width: 60px;
        height: 60px;
        line-height: 60px;
        border-radius: 50%;
        overflow: hidden;
        font-size: 18px;
        text-align: center;
        color: #2693F1;
        background: #E7F4ff;
    }
    .delete-icon {
        position: absolute;
        top: 4px;
        right: 4px;
        width: 14px;
        height: 14px;
        cursor: pointer;
    }
  .workerDivRight {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
  }
}
.btn-box-fixed {
  position: fixed;
  bottom: 10px;
  height: 50px;
  width: 560px;
  background: #fff;
  z-index: 99;
  margin-bottom: 0px !important;
  display: flex;
  justify-content: center;
  align-items: center;
}
.layout-content #contentManage {
  padding-left: 0;
}
#contentManage {
  padding-left: 10px;
  padding-right: 20px;
  .bread {
    display: flex;
    justify-content: space-between;
    height: 56px;
    line-height: 56px;
    .bread-content {
      .breadHead {
        font-weight: 700;
        cursor: pointer;
        &:hover {
          color: #2ed095;
        }
      }
    }
    .right {
      width: 260px;
      margin-top: auto;
      padding: 0 40px;
      height: 36px;
      line-height: 36px;
      color: #fff;
      background: #2ed095;
      border-radius: 5px 5px 0px 0px;
      .right_title {
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        .right_siteName {
          text-align: center;
          width: 260px;
          text-overflow: ellipsis; /*让截断的文字显示为点点。还有一个值是clip意截断不显示点点*/
          white-space: nowrap; /*让文字不换行*/
          overflow: hidden; /*超出要隐藏*/
        }
        img {
          width: 20px;
          height: 15px;
        }
      }
    }
  }
  .tabs {
    background: #e6fff5;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-right: 30px;
    .tab {
      display: inline-block;
      width: 160px;
      line-height: 53px;
      text-align: center;
      color: #505050;
      cursor: pointer;
      &.active {
        color: #2ed095;
        background: #fff;
      }
    }
  }
}
.siteBox {
  background: #f8fffb;
  border: #2ed095 1px solid;
  position: absolute;
  width: 260px;
  padding: 10px;
  top: 54px;
  right: 20px;
  z-index: 300;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  .siteBox_item {
    margin-bottom: 20px;
    text-align: center;
    div {
      width: 200px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      text-overflow: ellipsis; /*让截断的文字显示为点点。还有一个值是clip意截断不显示点点*/
      white-space: nowrap; /*让文字不换行*/
      overflow: hidden; /*超出要隐藏*/
      .site_btn {
        // padding: 5px;
        // border: 1px solid #2ed095;
        color: #2ed095;
        cursor: pointer;
        margin-right: 10px;
      }
      .site_active {
        // padding: 5px;
        border: 1px solid #2ed095;

        cursor: pointer;
        background: #2ed095;
        color: #fff;
      }
    }
  }
  .siteBox_btns {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  span {
    color: #2ed095;
  }
}
.plainBtn {
  border-color: #2ed095 !important;
  color: #2ed095;
}
</style>
<style lang="scss">
.add-match .el-button {
  width: 100px;
  height: 36px;
}
.right-dialog {
  .el-input,
  .el-textarea {
    width: 360px;
  }
}
.dalogBox {
  width: 100vw;
  height: 100vh;
  position: absolute;
  top: 0;
  left: 0;
  // background-color: #fff;
}
.column-tree {
  .is-leaf {
    padding: 0 6px;
    &::before {
      content: "";
    }
    &::after {
      // vertical-align: 0;
      content: "";
      display: inline-block;
      width: 6px;
      height: 6px;
      // border-radius: 50%;
      // border: 1px solid #c0c4cc;
      // cursor: pointer;
    }
  }
  .el-tree-node {
    .el-tree-node__expand-icon {
      margin-left: 20px !important;
    }
  }
  .el-tree-node__content {
    // padding-left: 20px !important;
    height: 40px;
    &.el-tree-node__label {
      color: #70d29e;
    }
  }
  .el-tree-node__expand-icon,
  .el-tree-node__label {
    padding: 6px;
  }
  &.el-tree--highlight-current
    .el-tree-node.is-current
    > .el-tree-node__content {
    background-color: #effbf7;
    color: #70d29e;
    .el-tree-node__expand-icon {
      color: #70d29e;
    }
    .el-tree-node__label {
      border-color: #70d29e;
    }
  }
}
</style>
